import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { ObjContext } from "./context";

export class Cauldron extends UnitType {
    readonly id = "cauldron";
    readonly displayName = "Cauldron";
    description() { return "Produces blood."; }
    maxCooldown() { return 1000; }
    make() { return new GameObj("player", "cauldron"); }
    aiAlwaysSteps(): boolean { return true; }
    step(ctx: ObjContext) {

        const { obj, x, y } = ctx;
        if (!obj || !obj.isReady(this.maxCooldown())) return;
        obj.setNotReady();

        const ownerFaction = ctx.game.influenceMap.get(x, y);
        if (ownerFaction) ctx.game.addResource(ownerFaction, "blood", 2);

    }
}
